import React from "react";
import { Table, Tag, Tooltip, Button, Space } from "antd";
import { EditOutlined, CheckCircleTwoTone, ClockCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import moment from "moment";
import { Link } from "react-router-dom";

const PagosIndex = ({ pagos, loading, userRole, handleEditPago, visibleColumns }) => {
  const allColumns = [
    {
      title: "Fecha Pago",
      dataIndex: "FechaPago",
      key: "FechaPago",
      width: 120,
      render: (text) => (text ? moment(text).format("DD/MM/YYYY") : <Tag color="default">N/D</Tag>),
    },
    {
      title: "Monto",
      dataIndex: "Monto",
      key: "Monto",
      width: 180,
      align: "right",
      render: (text, record) => {
        const status = record.Status;
        let statusIcon;
        switch (status) {
          case 1:
            statusIcon = <ClockCircleTwoTone twoToneColor="#faad14" />;
            break;
          case 2:
            statusIcon = <CheckCircleTwoTone twoToneColor="#52c41a" />;
            break;
          case 3:
            statusIcon = <CloseCircleTwoTone twoToneColor="#ff4d4f" />;
            break;
          default:
            statusIcon = null;
        }

        return (
          <Space>
            {text ? (
              `${Number(text)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            ) : (
              <Tag color="default">N/D</Tag>
            )}
            {statusIcon}
          </Space>
        );
      },
    },
    {
      title: "Moneda",
      dataIndex: "Moneda",
      key: "Moneda",
      render: (text) => (text ? text : <Tag color="default">N/D</Tag>),
    },
    {
      title: "T. Cambio",
      dataIndex: "TipoCambio",
      key: "TipoCambio",
      render: (text) => (text ? text : <Tag color="default">N/D</Tag>),
    },
    {
      title: "Método",
      dataIndex: "Metodo",
      key: "Metodo",
      render: (text) => (text ? text : <Tag color="default">N/D</Tag>),
    },
    {
      title: "Control Interno",
      dataIndex: "ControlInterno",
      key: "ControlInterno",
      render: (text, record) => {
        if (text) {
          if (userRole === "director") {
            return <Link to={`/verificaciones/${record.VerificacionID}`}>{text}</Link>;
          }
          return text;
        }
        return <Tag color="default">N/D</Tag>;
      },
    },
    {
      title: "Folio Factura",
      dataIndex: "FacturaFolio",
      key: "FacturaFolio",
      render: (text) => (text ? text : <Tag color="default">N/D</Tag>),
    },
    {
      title: "Referencia",
      dataIndex: "ReferenciaPago",
      key: "ReferenciaPago",
      render: (text) => (text ? text : <Tag color="default">N/D</Tag>),
    },

    {
      title: "Notas",
      dataIndex: "Notas",
      key: "Notas",
      render: (text) => {
        if (text === null) {
          return <Tag color="default">N/D</Tag>;
        } else {
          const displayText = text.length > 50 ? `${text.substring(0, 50)}...` : text;
          return (
            <Tooltip title={text}>
              <span className="break-by-word">{displayText}</span>
            </Tooltip>
          );
        }
      },
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (text, record) => <Button type="primary" size="small" icon={<EditOutlined />} onClick={() => handleEditPago(record)} />,
    },
  ];

  const columns = allColumns.filter(
    (col) => visibleColumns.includes(col.title) || col.key === "acciones" || col.key === "FechaPago" || col.key === "Monto"
  );

  return (
    <Table
      columns={columns}
      dataSource={pagos}
      loading={loading}
      rowKey="PagoID"
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
      }}
    />
  );
};

export default PagosIndex;
